import React from 'react';
import { Link } from 'react-router-dom';
import BrandsCarousel from '../components/BrandsCarousel';
import PopularProducts from '../components/PopularProducts';
import WhyChooseUs from '../components/WhyChooseUs';
import FAQ from '../components/FAQ';
import HomeCarousel from '../components/HomeCarousel';
import { ShoppingBag, Circle } from 'lucide-react';

export default function HomePage() {

  return (
    <div className="min-h-screen mt-4 md:mt-10">
      {/* Мобильные кнопки каталога */}
      <div className="md:hidden px-4 mb-6">
        <div className="flex flex-col gap-3">
          <Link 
            to="/catalog-widget" 
            className="flex items-center justify-center gap-3 px-6 py-4 bg-black text-white font-semibold rounded-xl border-2 border-black hover:bg-white hover:text-black transition-all duration-300"
          >
            <ShoppingBag className="w-6 h-6" />
            <span className="text-lg">Каталог автозапчастей</span>
          </Link>
          <Link 
            to="/tyres" 
            className="flex items-center justify-center gap-3 px-6 py-4 bg-black text-white font-semibold rounded-xl border-2 border-black hover:bg-white hover:text-black transition-all duration-300"
          >
            <Circle className="w-6 h-6" />
            <span className="text-lg">Каталог шин</span>
          </Link>
        </div>
      </div>

      {/* Hero Section - слайдер */}
      <div className="hidden md:block max-w-7xl mx-auto px-0 sm:px-1 lg:px-2 mb-8">
        <HomeCarousel />
      </div>

      {/* Brands Section - только для десктопа */}
      <div className="hidden md:block">
        <BrandsCarousel />
      </div>

      {/* FAQ Section */}
      <FAQ />
    </div>
  );
} 